export default {
  LOGIN: "Login",
  FORGET_PASSWORD: "Forget Password",
  OTP_VERIFICATION: "OTP Verification",
  LOGOUT: "Logout",
  REGISTER: "Register",
  RESET_PASSWORD: "Reset Password",
  BLS_FEEDBACK: "BLS Feedback",
  CUSTOMER_MANAGEMENT: "Customer Management",
  CUSTOMER_DETAILS: "Customer Details",
  NOTIFICATION_MANAGEMENT: "Notification Management",
  VIEW_NOTIFICATION: "View Notification",
  EDIT_NOTIFICATION: "Edit Notification",
  ADD_NOTIFICATION: "Add Notification",
  EDIT_PROFILE: "Edit Profile",
  CHANGE_PASSWORD: "Change Password",
  CLICK_ANALYTICS: "Click Analytics",
  CLICK_ANALYTICS_DETAILS: "Click Analytics Details",
  USER_ANALYTICS: "User Analytics",
};
